import { useEffect, useState } from "react";
import { Impersonation, tokenStore } from "@services/tokenStore";

/** The active impersonation, or `undefined` when acting as yourself. */
export const useImpersonation = (): Impersonation | undefined => {
  const [impersonation, setImpersonation] = useState(() =>
    tokenStore.getImpersonation()
  );

  useEffect(() => {
    setImpersonation(tokenStore.getImpersonation());
    return tokenStore.subscribe(() => {
      setImpersonation(tokenStore.getImpersonation());
    });
  }, []);

  return impersonation;
};
